export default {
  mutations: {
    SET_TRANSACTION_STATS: 'SET_TRANSACTION_STATS',
  },
  getters: {
    GET_TRANSACTION_STATS: 'GET_TRANSACTION_STATS',
  },
  actions: {
    FETCH_TRANSACTION_STATS: 'FETCH_TRANSACTION_STATS',
  },
};
